if (!customElements.get("accordion-wrapper")) {
  class Accordion extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.options = this.dataset.options;
      this.multipleActive = this.dataset.multipleActive === "true";
      this.defaultOpen = this.dataset.defaultOpen === "true";
      this.items = this.querySelectorAll(".accordion__item");
      this.handleContentRefresh = this.refresh.bind(this);
      this.handleEscape = this.onEscape.bind(this);
    }

    connectedCallback() {
      this.bindEvents();
      this.addEventListener("content-refreshed", this.handleContentRefresh);
      this.addEventListener("keydown", this.handleEscape);
    }

    disconnectedCallback() {
      this.removeEventListener("content-refreshed", this.handleContentRefresh);
      this.removeEventListener("keydown", this.handleEscape);
      this.items.forEach((item) => {
        const toggle = this.getToggle(item);
        if (toggle && item._accordionToggleHandler) {
          toggle.removeEventListener("click", item._accordionToggleHandler);
        }
      });
    }

    bindEvents() {
      this.items.forEach((item) => {
        this.bindToggleEvent(item);
        if (item.dataset.open || this.defaultOpen) {
          this.expandItem(item);
        } else {
          this.collapseItem(item);
        }
      });

      if (this.defaultOpen) {
        this.classList.add("mobile-facets__initialized");
      }
    }

    getToggle(item) {
      return item.querySelector("[data-td-accordion-toggle], .accordion__toggle");
    }

    getContent(item) {
      return item.querySelector("[data-td-accordion-content], .accordion__content");
    }

    setExpandedState(item, isExpanded) {
      const toggle = this.getToggle(item);
      const content = this.getContent(item);

      if (toggle) {
        toggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
      }

      if (content) {
        content.setAttribute("aria-hidden", isExpanded ? "false" : "true");
      }
    }

    expandItem(item) {
      const content = this.getContent(item);
      if (!content) {
        return;
      }

      item.classList.add("is-active");
      content.style.maxHeight = content.scrollHeight + "px";
      this.setExpandedState(item, true);
    }

    collapseItem(item) {
      const content = this.getContent(item);
      if (!content) {
        return;
      }

      item.classList.remove("is-active");
      content.style.maxHeight = null;
      this.setExpandedState(item, false);
    }

    bindToggleEvent(item) {
      const toggle = this.getToggle(item);
      if (toggle && !item._accordionToggleHandler) {
        item._accordionToggleHandler = (event) => {
          event.preventDefault();
          this.toggle(item.dataset.item);
        };

        toggle.addEventListener("click", item._accordionToggleHandler);
      }
    }

    onEscape(event) {
      if (event.key !== "Escape") {
        return;
      }

      const activeItem = Array.from(this.items).find((item) =>
        item.classList.contains("is-active")
      );

      if (!activeItem) {
        return;
      }

      this.collapseItem(activeItem);

      const toggle = this.getToggle(activeItem);
      if (toggle && typeof toggle.focus === "function") {
        toggle.focus();
      }
    }

    refresh() {
      this.items = this.querySelectorAll(".accordion__item");
      this.items.forEach((item) => {
        this.bindToggleEvent(item);
        if (item.classList.contains("is-active")) {
          this.expandItem(item);
        } else {
          this.collapseItem(item);
        }
      });
    }

    toggle(itemId) {
      this.items.forEach((item) => {
        if (item.dataset.item == itemId && !item.classList.contains("is-active")) {
          this.expandItem(item);
        } else if (item.dataset.item == itemId && item.classList.contains("is-active")) {
          this.collapseItem(item);
        } else if (!this.multipleActive) {
          this.collapseItem(item);
        }
      });
    }
  }

  customElements.define("accordion-wrapper", Accordion);
}
